import { render, staticRenderFns } from "./consultations-filter.vue?vue&type=template&id=23acb23c&"
import script from "./consultations-filter.vue?vue&type=script&lang=ts&"
export * from "./consultations-filter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports